import { DROP_LIST_THEMES } from '@/utils/components-configurations/app-droplist'

export const TOOLTIP_CONFIGURATION = {
  placement: 'top',
  theme: `${DROP_LIST_THEMES.COMMON_TOOLTIP_THEMES} ${DROP_LIST_THEMES.TEXT_CENTER}`,
  delay: [1000, 200],
  followCursor: 'initial'
}
